import { useState } from 'react'

import { FormControl, type IFormikFormControlProps } from './FormControl'
import {
  DeprecatedDateRangePicker,
  type IDeprecatedDateRangePickerProps,
} from '../../elements/DeprecatedDatepicker/'

interface IFormDateRangePickerProps
  extends
    Pick<
      IFormikFormControlProps,
      Exclude<keyof IFormikFormControlProps, 'children'>
    >,
    Pick<
      IDeprecatedDateRangePickerProps,
      Exclude<
        keyof IDeprecatedDateRangePickerProps,
        | 'startDate'
        | 'startDateId'
        | 'endDate'
        | 'endDateId'
        | 'onDatesChange'
        | 'onFocusChange'
        | 'focusedInput'
      >
    > {
  focused?: boolean
  disabled?: boolean
}

export const FormDateRangePicker = ({
  name,
  disabled,
  id,
  label,
  helperText,
  required,
  fullWidth,
  focused,
  ...DatepickerProps
}: IFormDateRangePickerProps) => {
  const [focusedInput, setFocusedInput] =
    useState<IDeprecatedDateRangePickerProps['focusedInput']>(null)

  const startDateId = `${id}_start`
  const endDateId = `${id}_end`

  return (
    <FormControl
      name={name}
      disabled={disabled}
      id={id}
      label={label}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
    >
      {({ value, handleChange, handleBlur, isSubmitting, error }) => {
        const { startDate, endDate } = value
        return (
          <DeprecatedDateRangePicker
            {...DatepickerProps}
            disabled={isSubmitting || disabled}
            startDate={startDate}
            endDate={endDate}
            startDateId={startDateId}
            endDateId={endDateId}
            onDatesChange={(dateRangeObj: {
              startDate: IDeprecatedDateRangePickerProps['startDate']
              endDate: IDeprecatedDateRangePickerProps['endDate']
            }) => handleChange(dateRangeObj)}
            onFocusChange={(_focusedInput) => {
              setFocusedInput(_focusedInput)
              if (!_focusedInput) {
                // https://github.com/jaredpalmer/formik/issues/2457
                setTimeout(() => handleBlur())
              }
            }}
            focusedInput={focusedInput}
            error={error}
          />
        )
      }}
    </FormControl>
  )
}
